import { createLocalAudioTrack } from '../../room/track/create';
import { Checker } from './checker';

export class PublishAudioCheck extends Checker {
  get description(): string {
    return 'Can publish audio';
  }

  async perform(): Promise<void> {
    const room = await this.connect();

    const track = await createLocalAudioTrack();
    room.localParticipant.publishTrack(track);
    // wait for a few seconds to publish
    await new Promise((resolve) => setTimeout(resolve, 3000));

    // verify RTC stats that it's publishing
    const stats = await track.sender?.getStats();
    track.stop();
    if (!stats) {
      throw new Error('Could not get RTCStats');
    }
    let numPackets = 0;
    let jitter: number = 0;
    let packetLost;
    let rtt: number = 0;
    let maxRTT: number = 0;
    let bitrate: number = 0;
    let maxBitrate;
    stats.forEach((stat) => {
      if (stat.type === 'outbound-rtp' && (stat.kind === 'audio' || (!stat.kind && stat.mediaType === 'audio'))) {
        numPackets = stat.packetsSent;
      }
      if (stat.type === 'candidate-pair') {
        bitrate = (stat.bytesSent * 8) / (stat.timestamp - stat.lastPacketSentTimestamp);
        maxBitrate = stat.availableOutgoingBitrate;
      }
      if (stat.type === 'remote-inbound-rtp' && (stat.kind === 'audio' || (!stat.kind && stat.mediaType === 'audio'))) {
        jitter = stat.jitter;
        packetLost = stat.fractionLost * 100;
        rtt = (stat.totalRoundTripTime / stat.roundTripTimeMeasurements) * 1000;
        maxRTT = stat.totalRoundTripTime * 1000;
      }
    });
    if (numPackets === 0) {
      throw new Error('Could not determine packets are sent');
    }
    this.appendMessage(`published ${numPackets} audio packets`);
    this.appendMessage(` ${jitter} `);
    this.appendMessage(`${packetLost} `);
    this.appendMessage(`{"avg":"${rtt}","max":"${maxRTT}"} `);
    this.appendMessage(`{"avg":"${bitrate}","max":"${maxBitrate}"} `);
  }
}
